import AModal from '@/components/A/AModal/AModal'
import styles from './ChangeAccountNameModal.module.less'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import AInput from '@/components/A/AInput/AInput'
import { useState } from 'react'
import { FormItem } from '@/pages/ProjectCreatePage/components/StepOne/StepOne'
import { api } from '@/api'
import { message } from 'antd'
import { useTranslation } from 'react-i18next'

interface Props {
  username: string
  onConfirm: (username: string) => void
  onCancel?: () => void
}

function ChangeAccountNameModal(props: Props) {
  const { t } = useTranslation()
  const modal = useModal()
  const [username, setUsername] = useState(props.username)
  const handleCancel = () => {
    props.onCancel?.()
    modal.hide()
  }
  const handleConfirm = async () => {
    await api.staff.updateUsername(username).send()
    message.success(t('dashboard.accountPage.message.userNameUpdatedSuccessfully'))
    props.onConfirm(username)
    modal.hide()
  }

  return (
    <AModal
      testId='account-change-username-modal'
      open={modal.visible}
      className={styles.changeAccountNameModal}
      title={t('dashboard.accountPage.message.changeUsername')}
      confirmText={t('dashboard.accountPage.message.confirm')}
      cancelText={t('dashboard.accountPage.message.cancel')}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      afterClose={() => {
        modal.remove()
      }}
    >
      <div style={{ marginBottom: 20 }}>
        <FormItem label={t('dashboard.accountPage.message.username')}>
          <AInput
            testId='account-change-username-input'
            placeholder={t('dashboard.accountPage.message.pleaseEnterTheNewUsername')}
            defaultValue={props.username}
            onChange={(e) => {
              setUsername(e.target.value)
            }}
          />
        </FormItem>
      </div>
    </AModal>
  )
}

export default NiceModal.create(ChangeAccountNameModal)
